<template>
<div class="chapter">
<div class="inner_page">
<div class="title">The Medicine of Memory</div>
<div class="sub-title">A MEXICA CLAN IN CALIFORNIA</div>
<div class="author">by Alejandro Murguía</div>
<div class="publisher"><img alt="image" src="images/logo.png" style="vertical-align:middle;"/> U<span class="small">NIVERSITY OF</span> T<span class="small">EXAS</span> P<span class="small">RESS</span>, A<span class="small">USTIN</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1dae635a